export const useModalCount = () => useState<number>('modalCount', () => 0)
